import { render, staticRenderFns } from "./ViewParent.vue?vue&type=template&id=1ee8cfb3"
import script from "./ViewParent.vue?vue&type=script&lang=js"
export * from "./ViewParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports